"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ctrnn = void 0;
const sigmoid_1 = require("./sigmoid");
/**
 * Continuous-Time Recurrent Neural Network (`CTRNN`) implementation for JS.
 *
 * # Example
 *
 * ```typescript
 * import Ctrnn from "ctrnn.js";
 * let ctrnn = new Ctrnn();
 * ```
 */
class Ctrnn {
    constructor(nodes = 4) {
        let opts = { length: nodes };
        this.nodes = Array.from(opts, () => ({ bias: 0, timeConstant: 1.0 }));
        this.weights = Array.from(opts, () => Array.from(opts, () => 0));
    }
    /**
     * Get the number of nodes in the network
     */
    get size() { return this.nodes.length; }
    /**
     * Set the `bias` and `timeConstant` parameters of a given node
     */
    setNode(index, node) {
        this.nodes[index] = Object.assign(Object.assign({}, this.nodes[index]), node);
    }
    /**
     * Set the the given weight from one node to another
     */
    setWeight(from, to, weight) {
        this.weights[to][from] = weight;
    }
    /**
     * Get the output activation of a specific node
     */
    getOutput(frame, node) {
        return sigmoid_1.sigmoid(frame[node] + this.nodes[node].bias);
    }
    /**
     * Get the output activations of all nodes
     */
    getOutputs(frame) {
        if (frame.length != this.size)
            throw new Error();
        return this.nodes.map((node, index) => sigmoid_1.sigmoid(frame[index] + node.bias));
    }
    frameFromOutput(output) {
        if (output.length != this.size)
            throw new Error();
        return output.map((voltage, index) => sigmoid_1.inverseSigmoid(voltage) - this.nodes[index].bias);
    }
    // TODO: Documentation
    tick(frame, inputs, dt) {
        const final = [];
        for (let i = 0; i < this.size; i++) {
            final.push(inputs[i] || (frame[i] + this.getDelta(frame, i) * dt));
        }
        return final;
    }
    // TODO: Documentation
    getDelta(frame, node) {
        const weights = this.weights[node];
        let sum = 0;
        for (let j = 0; j < this.size; j++) {
            const activation = sigmoid_1.sigmoid(frame[j] + this.nodes[j].bias);
            sum += weights[j] * activation;
        }
        return (sum - frame[node]) / this.nodes[node].timeConstant;
    }
    static newFrame(size) {
        return Array.from({ length: size }, () => 0.0);
    }
}
exports.Ctrnn = Ctrnn;
